import {
  Divider,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
  Chip,
} from '@material-ui/core';
import { useBoolean } from '@lib/common';
import { Fragment, memo, useEffect, useState } from 'react';
import { CompanyMasters } from '@api/masters';
import styled from 'styled-components';
import getLoadingMessage from '@lib/common/loading-messages';
import { Autocomplete } from '@material-ui/lab';

export const ServiceDialogContent = memo<any>(
  ({
    servicesLength,
    onSearch,
    serviceOptions,
    handleServiceClick,
    reducerState,
    defaultSelected = [],
  }) => {
    const [showList, openList] = useBoolean(false);
    const [selectedServices, setSelectedServices] = useState(defaultSelected);
    useEffect(() => {
      // Small optimization to open the dialog faster.
      setTimeout(openList, 100);
      // Clear results on unmount
      return () => onSearch({ target: { value: '' } });
    }, []);

    useEffect(() => {
      if (reducerState.okPressed) {
        handleServiceClick && handleServiceClick(selectedServices);
      }
    }, [reducerState]);
    return (
      <>
        <Autocomplete
          multiple
          fullWidth
          filterSelectedOptions
          value={selectedServices}
          // open={showList}
          onChange={(evt, v) => {
            // onChange && onChange(v)
            setSelectedServices(prevState => v);
          }}
          options={serviceOptions}
          getOptionLabel={(option: CompanyMasters.Service & { highlighted: string }) =>
            option['service'] + option['service_aka']
          }
          getOptionSelected={(option, value) => option.id === value.id}
          renderTags={(value, getTagProps) => {
            return value.map((option, index) =>
              index == 0 ? (
                <Chip color="primary" label={option.service} {...getTagProps({ index })} />
              ) : (
                <Chip color="secondary" label={option.service} {...getTagProps({ index })} />
              )
            );
          }}
          renderOption={(s: CompanyMasters.Service & { highlighted: string }) => (
            <Fragment key={`${s.id}-${s.highlighted}`}>
              {/* <ListItem button onClick={handleServiceClick && handleServiceClick(s)}> */}
              <ListItemText>
                {s.highlighted ? (
                  <span
                    style={{ fontSize: '0.875rem' }}
                    dangerouslySetInnerHTML={{
                      __html: `${s.highlighted}`,
                    }}
                  />
                ) : (
                  <span style={{ fontSize: '0.875rem' }}>
                    {`${s.service}`}
                    <small style={{ color: 'rgba(0,0,0,0.54)' }}>{`${
                      s.service_aka ? ' ( ' + s.service_aka + ' ) ' : ''
                    }`}</small>
                  </span>
                )}
              </ListItemText>
              {/* </ListItem> */}
              <Divider />
            </Fragment>
          )}
          renderInput={props => (
            <TextField
              helperText={
                serviceOptions.length === servicesLength
                  ? 'Type to search...'
                  : serviceOptions.length
                  ? `Showing ${serviceOptions.length} existing services/service A.K.A`
                  : 'Not matching any existing services/service A.K.A!'
              }
              label={'Services'}
              placeholder={'Services'}
              fullWidth
              variant="outlined"
              onChange={onSearch}
              {...props}
            />
          )}
        />
        {/* <ListContainer>
          {!showList ? (
            <Typography color="textSecondary" className="loading" component="span">
              {getLoadingMessage()}
            </Typography>
          ) : (
            <List dense className="list">
              {serviceOptions.map((s: CompanyMasters.Service & { highlighted: string }) => (
                <Fragment key={`${s.id}-${s.highlighted}`}>
                  <ListItem button onClick={handleServiceClick && handleServiceClick(s)}>
                    <ListItemText>
                      {s.highlighted ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${s.highlighted} <small style='color:rgba(0,0,0,0.54)'>${
                              s.service_aka ? ' ( ' + s.service_aka + ') ' : ''
                            }</small>`,
                          }}
                        />
                      ) : (
                        <span>
                          {`${s.service}`}
                          <small style={{ color: 'rgba(0,0,0,0.54)' }}>{`${
                            s.service_aka ? ' ( ' + s.service_aka + ' ) ' : ''
                          }`}</small>
                        </span>
                      )}
                    </ListItemText>
                  </ListItem>
                  <Divider />
                </Fragment>
              ))}
            </List>
          )}
        </ListContainer> */}
      </>
    );
  }
);
const ListContainer = styled.div`
  height: 47vh;
  border: 1px solid #a1a1a1;
  overflow: auto;
  .list {
    padding: 0;
  }
  .loading {
    padding: 30px;
    display: block;
  }
`;
